<template>
  <v-list-item two-line link :to="getAccountRouteHandler">
    <v-list-item-content>
      <v-list-item-title>{{ collection.name }}</v-list-item-title>
      <v-list-item-subtitle>{{ typeName }}</v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script lang="ts">
import mixins from 'vue-typed-mixins';
import { PropType } from 'vue';

import { AccountLayoutMixin } from '@/bundles/App/mixins/accountMixin';
import { ICollection } from '@/bundles/Tasks/interfaces/ITask';
import { getTaskRelatedRecordRoute, IGetAccountRouteHandler } from '@/bundles/App/helpers';

export default mixins(AccountLayoutMixin).extend({
  name: 'CollectionTile',

  props: {
    collection: {
      type: Object as PropType<ICollection>,
      required: true,
    }
  },

  computed: {
    typeName (): string {
      if (this.collection.type === 'savedset') {
        return 'Saved Set';
      }

      return this.collection.type;
    },
    page: function (): string {
      if (this.collection.address === 'comparable') {
        return 'comparables';
      } else if (this.collection.address === 'request') {
        return 'administration-requests';
      } else if (this.collection.address === 'deal') {
        return 'deals';
      }

      return this.collection.address;
    },
    getAccountRouteHandler (): IGetAccountRouteHandler {
      return this.getAccountRoute(getTaskRelatedRecordRoute(this.collection));
    }
  },
});
</script>
